import React from 'react';
import { Button } from '../Button';
import SEO from '../SEO';
import '../styles/pages.css';

/**
 * Products Page - Services and solutions showcase
 */
export default function Products() {
  const products = [
    {
      id: 1,
      name: 'Cloud Infrastructure',
      description: 'Enterprise-grade cloud solutions with multi-cloud support',
      features: ['AWS', 'Azure', 'GCP', 'Hybrid Cloud'],
      price: 'Custom',
      color: 'cyan'
    },
    {
      id: 2,
      name: 'DevOps Automation',
      description: 'CI/CD pipelines and infrastructure as code solutions',
      features: ['Jenkins', 'GitLab', 'Docker', 'Kubernetes'],
      price: 'Custom',
      color: 'purple'
    },
    {
      id: 3,
      name: 'AI & Machine Learning',
      description: 'Custom ML models and AI-powered applications',
      features: ['TensorFlow', 'PyTorch', 'NLP', 'Computer Vision'],
      price: 'Custom',
      color: 'red'
    },
    {
      id: 4,
      name: 'Data Analytics',
      description: 'Big data processing and business intelligence',
      features: ['Apache Spark', 'Hadoop', 'Power BI', 'Tableau'],
      price: 'Custom',
      color: 'green'
    }
  ];

  return (
    <main className='products-page'>
      <SEO
        title='Our Solutions'
        description='Cutting-edge technology services for modern enterprises: cloud infrastructure, DevOps automation, AI & machine learning, and data analytics.'
        path='/products'
      />
      <div className='section-header'>
        <h1>Our Solutions</h1>
        <p>Cutting-edge technology services for modern enterprises</p>
      </div>

      <div className='products-grid'>
        {products.map(product => (
          <div key={product.id} className={`product-card glass-dark product-${product.color}`}>
            <div className='product-header'>
              <h3>{product.name}</h3>
              <div className='product-badge'>{product.price}</div>
            </div>
            <p className='product-description'>{product.description}</p>
            <div className='product-features'>
              {product.features.map((feature, idx) => (
                <span key={idx} className='feature-tag'>
                  {feature}
                </span>
              ))}
            </div>
            <Button buttonStyle='btn--outline' buttonSize='btn--medium'>
              Learn More
            </Button>
          </div>
        ))}
      </div>

      {/* Comparison Section */}
      <section className='comparison-section'>
        <h2>Service Tiers</h2>
        <div className='pricing-table'>
          <div className='pricing-column'>
            <h3>Starter</h3>
            <div className='price'>$999<span>/month</span></div>
            <ul>
              <li>✓ Up to 2 projects</li>
              <li>✓ Email support</li>
              <li>✓ Basic monitoring</li>
            </ul>
            <Button buttonStyle='btn--outline'>Choose Plan</Button>
          </div>
          <div className='pricing-column featured'>
            <h3>Professional</h3>
            <div className='price'>$2,999<span>/month</span></div>
            <ul>
              <li>✓ Unlimited projects</li>
              <li>✓ Priority support</li>
              <li>✓ Advanced monitoring</li>
              <li>✓ Custom integrations</li>
            </ul>
            <Button buttonStyle='btn--primary'>Popular</Button>
          </div>
          <div className='pricing-column'>
            <h3>Enterprise</h3>
            <div className='price'>Custom</div>
            <ul>
              <li>✓ Everything in Pro</li>
              <li>✓ 24/7 dedicated support</li>
              <li>✓ Custom SLA</li>
              <li>✓ On-premise options</li>
            </ul>
            <Button buttonStyle='btn--outline'>Contact Sales</Button>
          </div>
        </div>
      </section>
    </main>
  );
}
